<script setup>
import SavedCards from '@/Components/Payments/SavedCards.vue'
import { TrashIcon, ShoppingCartIcon } from "@heroicons/vue/outline"

import { ref, computed, onMounted } from "vue"

import { useAuthStore } from '@/Stores/auth.js'
const auth = useAuthStore()

import { usePaymentsStore } from '@/Stores/payments'
const payments = usePaymentsStore()

import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()

const canManagePaymentsOn = computed(() => auth.whereCan('manage_payment_methods', 'organisations'))

const props = defineProps({
	organisation: {
		type: Object,
		required: true,
	},
})

const selectedCard = ref(null)

function selectCard(card){
	if( selectedCard.value === card ){
		selectedCard.value = null
	} else {
		selectedCard.value = card
	}
}

function warnNoSelectedCard(){
	if( selectedCard.value === null ){
		errors.push({
			type: 'warning',
			title: 'No card selected',
			message: 'Please select a card before continuing',
		})
		return false
	}
	// else
	return true
}

function deleteCard(){
	if(warnNoSelectedCard()){
		payments.deleteCard(selectedCard.value)
		selectedCard.value = null
		payments.fetchSavedCards()
	}
}

function setAutomaticPaymentMethod(){
	if(warnNoSelectedCard()){
		payments.setCardable('organisation', props.organisation.id)
		payments.setAutomaticPaymentMethod('card', selectedCard.value.id).then(() => {
			selectedCard.value = null
			payments.fetchSavedCards()
		})
	}
}

function addPaymentMethod(){
	payments.showSaveCardForm('organisation', props.organisation.id)
}

onMounted(() => {
	payments.setCardable('organisation', props.organisation.id)
	payments.fetchSavedCards()
})
</script>

<template>
	<SectionCard title="Payment Methods" data-testid="manage-cards-section-card">
		<SavedCards 
			:cardable-id="'' + organisation.id" 
			:selected-card="selectedCard"
			@select-card="selectCard"
		/>
		<template #footer>
			<div class="flex justify-end">
				<Button
					color="blue"
					class="mr-1"
					:status="selectedCard === null ? 'disabled' : ''"
					:disabled="!selectedCard"
					@click="setAutomaticPaymentMethod"
					data-testid="set-automatic-payment-method-button"
				>
					<template #icon>
						<ShoppingCartIcon class="w-4 h-4" />
					</template>
					Toggle automatic payment method
				</Button>
				<Button
					color="red"
					class="mr-1"
					:status="selectedCard === null ? 'disabled' : ''"
					:disabled="!selectedCard"
					@click="deleteCard"
					data-testid="delete-card-button"
				>
					<template #icon>
						<TrashIcon class="w-4 h-4" />
					</template>
					Remove Selected Card
				</Button>
				<Button
					color="blue"
					@click="addPaymentMethod"
					data-testid="add-payment-method-button"
				>
					<template #icon>
						<PlusIcon class="w-4 h-4" />
					</template>
					Add payment method
				</Button>
			</div>
		</template>
	</SectionCard>
</template>